import { render, staticRenderFns } from "./ServiceRepairHistory.vue?vue&type=template&id=7f98e4c4"
import script from "./ServiceRepairHistory.vue?vue&type=script&lang=js"
export * from "./ServiceRepairHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports